// validateRRN and birthDateFromRRN live in @dermalink/shared so the backend
// can import the same logic without duplication.
export { validateRRN, birthDateFromRRN } from '@dermalink/shared';

/**
 * Formats a raw digit string into the Belgian RRN display format:
 * JJ.MM.DD-SSS-CC (e.g. "85.07.30-033-28").
 * Safe to call on partial input — formats as many groups as possible.
 * This is UI-only (display/input formatting) so it stays in the web app.
 */
export function formatRRN(value: string): string {
  const d = value.replace(/\D/g, '').slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 4) return `${d.slice(0, 2)}.${d.slice(2)}`;
  if (d.length <= 6) return `${d.slice(0, 2)}.${d.slice(2, 4)}.${d.slice(4)}`;
  if (d.length <= 9) return `${d.slice(0, 2)}.${d.slice(2, 4)}.${d.slice(4, 6)}-${d.slice(6)}`;
  return `${d.slice(0, 2)}.${d.slice(2, 4)}.${d.slice(4, 6)}-${d.slice(6, 9)}-${d.slice(9)}`;
}
